import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
} from '@mui/material';
import { InternalFieldRenderer } from '../Types';

export const renderCheckboxField: InternalFieldRenderer = (
  props,
  { label, value, ...field },
  { message, ...fieldState },
) => (
  <FormControl error={fieldState.invalid}>
    <FormControlLabel
      control={<Checkbox checked={value} {...field} {...props} />}
      label={label}
      sx={{ width: 'fit-content' }}
    />
    {message && <FormHelperText>{message}</FormHelperText>}
  </FormControl>
);
